/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Forbidden_TitleInputs */

const vi_warehouse_sales_forbidden_title = /** @type {(inputs: Warehouse_Sales_Forbidden_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không có quyền xem trang này`)
};

/**

* @param {Warehouse_Sales_Forbidden_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_forbidden_title = /** @type {((inputs?: Warehouse_Sales_Forbidden_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Forbidden_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_forbidden_title(inputs)
});